


































































import Vue from 'vue';
import { mapActions } from 'vuex';
import { find, cloneDeep } from 'lodash';
import { BRow, BCol, BFormCheckbox } from 'bootstrap-vue';

import ZenButton from '@reciprocity/button';
import ZenMultiselect from '@reciprocity/multiselect';

import { ModelMetaSchema } from '@/types/apiTypes';

import { ObjectTypeDropdownOption, RelatedFilter } from '../types';

export default Vue.extend({
  name: 'RelatedFilters',
  components: {
    BCol,
    BFormCheckbox,
    BRow,
    ZenMultiselect,
    ZenButton,
  },
  props: {
    value: {
      type: Array as () => RelatedFilter[],
      required: true,
    },
    showRelevantCheckbox: {
      type: Boolean,
      required: true,
    },
    relevantCheckboxValue: {
      type: Boolean,
      required: true,
    },
    allowedFilterTypes: {
      type: Array as () => string[],
      required: true,
    },
    modelMeta: {
      type: Object as () => ModelMetaSchema[],
      required: true,
    },
  },
  data() {
    return {
      filterLoading: false,
    };
  },
  computed: {
    allowedFilterTypeOptions(): ObjectTypeDropdownOption[] {
      return this.allowedFilterTypes.map((modelSingular: string) => {
        const modelMeta = find(this.modelMeta, { modelSingular });
        return {
          label: modelMeta.titlePlural,
          id: modelMeta.modelSingular,
        };
      });
    },
  },
  methods: {
    ...mapActions({
      loadEmptyFilter: 'export/loadEmptyFilter',
    }),
    getValueFromId(objects: object[], id: number) {
      return find(objects, { id });
    },
    update(changeCallback: (filters: RelatedFilter[]) => void) {
      const newFilters: RelatedFilter[] = cloneDeep(this.value);
      changeCallback(newFilters);
      this.$emit('input', newFilters);
    },
    async changeRelevantType(index: number, newType: string) {
      const newFilter = await this.loadEmptyFilter(newType);
      this.update(filters => (filters[index] = newFilter));
    },
    async changeObjectId(index: number, newId: number) {
      this.update(filters => (filters[index].objectId = newId));
    },
    async addFilter() {
      this.filterLoading = true;
      const newFilter = await this.loadEmptyFilter(this.allowedFilterTypes[0]);
      this.update(filters => filters.push(newFilter));
      this.filterLoading = false;
    },
    removeFilter(index: number) {
      this.update(filters => filters.splice(index, 1));
    },
  },
});
